import { render } from "./PricingPage.vue?vue&type=template&id=8faac406&scoped=true"
import script from "./PricingPage.vue?vue&type=script&lang=js"
export * from "./PricingPage.vue?vue&type=script&lang=js"

import "./PricingPage.vue?vue&type=style&index=0&id=8faac406&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8faac406"]])

export default __exports__